import { Injectable } from '@angular/core';
import { stringify } from 'querystring';
import { Objetive, FiltratedObjetives, AntecedentesMarcas, Distancias, AchievementDynamic, Antecedente, FilteredMode, FiltratedUser } from 'src/app/api/interfaces/register';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { AntecedentesEnum } from 'src/app/enums/antecedentes';
import { HoursDayFixedService } from 'src/app/utils/hoursDayFixed/hours-day-fixed.service';
import { ParseTimeService } from 'src/app/utils/parseTime/parse-time.service';

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {

  constructor(
    private parseTime: ParseTimeService,
    private registerService: RegisterService,
    private hourDayFixed: HoursDayFixedService,
  ) { }

  public filterObjetives(input: Objetive[]): FiltratedObjetives[] {
    let objetivesArray = Array();
    if (input.length > 0 && input[0].name) {
      input.forEach(element => {
        let aux: FiltratedObjetives;
        if (element.date) {

          // bugfix date
          let fechaCorregida : string = this.hourDayFixed.getDateFixed(new Date(element.date).toISOString());

          aux = {
            objetivoDescripcion: element.name,
            fechaObjetivo: fechaCorregida,
            id: element.id ? element.id : null,
          }
        } else {
          aux = {
            objetivoDescripcion: element.name,
            fechaObjetivo: null,
            id: element.id ? element.id : null,
          }
        }
        objetivesArray.push(aux);
      });
      return objetivesArray;
    } else {
      return null;
    }
  }

  public filterObjetive(input: Objetive): FiltratedObjetives {
    if (input) {
      let aux: FiltratedObjetives;
      if (input.date) {

        let fechaCorregida: string = input.date.toString();

        // bugfix date
        if(!input.date.toString().includes('T12') && input.date.toString().includes('GMT')) {
          fechaCorregida = this.hourDayFixed.getDateFixed(input.date.toISOString());
        }

        aux = {
          objetivoDescripcion: input.name,
          id: input.id,
          fechaObjetivo: fechaCorregida
        }
      } else {
        aux = {
          objetivoDescripcion: input.name,
          fechaObjetivo: null,
          id: input.id,
        }
      }
      return aux;
    } else {
      return null;
    }
  }

  public completeAchievement(input: any, mode: string, valid: boolean): AchievementDynamic {
    if (mode === "pista" || mode === "ultra" || mode === "trail") {
        let id: number;
        let optionId: number;
        switch (mode) {
          case "pista":
            id = AntecedentesEnum.PISTA;
            optionId = 3;
            break;
          case "ultra":
            id = AntecedentesEnum.ULTRA;
            optionId = 4;
            break;
          case "trail":
            id = AntecedentesEnum.TRAIL;
            optionId = 4;
            break;
        }
        let time: number[] = this.parseTime.parseTime(input.time);
        let aux: AchievementDynamic = {
          tiempoMarcaHoras: time[0],
          tiempoMarcaMinutos: time[1],
          tiempoMarcaSegundos: time[2],
          distanciaMarca: input.distance,
          fechaMarca: input.date ? input.date : "",
          antecedentePreguntaDetalleId: id,
          distanciaTipoId: input.distanciaTipoId? input.distanciaTipoId: optionId,
          id: input.id,
        };
        return aux;
    } else {
      let time: number[] = this.parseTime.parseTime(input.time);
      let aux: AchievementDynamic = {
        distanciaTipoId: input.type.id,
        tiempoMarcaHoras: time[0],
        tiempoMarcaMinutos: time[1],
        tiempoMarcaSegundos: time[2],
        fechaMarca: input.date ? input.date : "",
        id: input.id,
        antecedentePreguntaDetalleId: AntecedentesEnum.RUTA,
      }
      return aux;
    }
    return null;
  }

  public filterBackground(input): Antecedente[] {

    let aux: Antecedente[] = [];
    
    const background: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.EXP,
      antecedenteRespuesta: input.background
    };
    aux.push(background);

    const days: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.FREQ,
      antecedenteRespuesta: input.days
    };
    aux.push(days);

    const trainingWeek: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.SEM,
      antecedenteRespuesta: input.trainingWeek ? input.trainingWeek : ""
    };
    aux.push(trainingWeek);

    const conditionName: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.EST,
      antecedenteRespuesta: input.condition.name
    };
    aux.push(conditionName);
    
    const complement: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.COMP,
      antecedenteRespuesta: input.complement ? input.complement : "No"
    };
    aux.push(complement);

    const restAndFood: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.DYA,
      antecedenteRespuesta: input.restAndFood
    };
    aux.push(restAndFood);

    const shoes: Antecedente = {
      antecedentePreguntaId: AntecedentesEnum.CALZ,
      antecedenteRespuesta: input.shoes
    };
    aux.push(shoes);
    
    // let aux: FiltratedBackground= {
      // background: input.background,
      // days: input.days,
      // trainingWeek: input.trainingWeek,
      // complement: input.complement,
      // conditionName: input.condition.name,
      // restAndFood: input.restAndFood,
      // shoes: input.shoes,
      // ruta: input.ruta,
      // pista: input.pista,
      // trail: input.trail,
      // ultra: input.ultra,
      // objetives: objetivesBoolean
    // }
    return aux;

  }

  filterUserData(data: any, filteredMode: FilteredMode, alumno_id: number) {
    let today = new Date().toISOString();
    let aux: FiltratedUser = {
      email: data.email,
      nombre: data.nombre,
      apellido: data.apellido,
      segundoApellido: data.segundoApellido ? data.segundoApellido: "",
      fechaNacimiento: data.fechaNacimiento,
      numeroDocumento: data.DNI,
      paisId: data.pais.id,
      residencia: data.residencia,
      prefijoCelular: data.prefijoCelular,
      numeroCelular: data.numeroCelular,
      prefijoEmergencia: data.prefijoEmergencia,
      numeroEmergencia: data.numeroEmergencia,
      peso: data.peso,
      altura: data.altura,
      entrenamientoTipoId: filteredMode.id,

      entrenamientoGrupoId: filteredMode.grupoId,
      entrenamientoNivelId: 1,
      entrenadorId: 1,
      activo: true,
      ultimaModificacion: today,
      ultimaModificacionPor: alumno_id,
      estado: "P",
      documentTipoId: data.documentoTipo.id,
      avatarUrl: null
    }
    return aux;
  }

  public filterDataMode(mode: any) {
    let filteredMode: FilteredMode;
    const ONLINE : number = 1;
    let dia;
    if(mode.days && mode.days.index) {
      dia = mode.days.index;
    } else {
      dia = null;
    }
    if(!mode.mode) {

      filteredMode = {
        entrenamientoTipo: "PRE",
        grupo: mode.trainingDays.entrenamientoGrupoDescripcion,
        id: 1,  //required from database
        dia: dia,
        grupoId: mode.trainingDays.id
      }
    } else {
      filteredMode = {
        entrenamientoTipo: "ONL",
        grupo: null,
        id: 2,  //required from database
        dia: dia,
        grupoId: 2,  //required from database
      }
    }
    return filteredMode;
  }


}
